import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";

import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "../../views/chart/chart.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {AlertComponent} from "../../views/modal/alert.component";
import { TemplateService } from "../template.service";
import { IStatResult } from "../../models/responce_result.model";

interface ISiteSubCategoryStats extends IStatResult{
	values: number[];
	categories: string[];
	totalCount: number;
}

@Component({
	selector: 'site-sub-categories',
	templateUrl: './site_sub_categories.component.html'
})
export class SiteSubCategoriesComponent extends BaseComponent {
	addFilterParams = {
		userType: 'user',
		isTemplateTag: true,
		dateFilters : ['dateCreated', 'dateSiteCreated', 'datePaid', 'dateAccessorView']
	};
	
	chartType: string = 'Category';
	
	values = [];
	categories = [];
	totalCount: number = 0;

	categoryLoader: boolean = false;

	categoryChart = new ChartParams();

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		public modalService: ModalService,
		public http: HttpClient,
		public helper: HelperService,
		public templateService: TemplateService,
	) {
		super(eventsService, templateService, activatedRoute, filter, translate);
	}

	async ngOnInit() {
		super.ngOnInit();
	}

	async getData() {
		await this.getStats();
	}	
	
	async getStats() {
		const me = this;
		
		me.categoryLoader = true;
		
		const { values, categories, totalCount } = await me.templateService.siteSubCategories.stats<ISiteSubCategoryStats>(
			me.filter.filterParams
		).toPromise();
		
		me.categoryChart.setOptions({
			title: 'Подкатегории',
			type : 'bar',
			padding: {
				top: 10,
				bottom: 0
			},
			size: {
				height: 4000
			},
			axis: {
				rotated: true,
				x: {
					type: 'category',
					categories: categories,
					tick: {
						multiline: false
					}
				}
			}
		});

		me.categoryChart.data = [values];

		me.values     = values;
		me.categories = categories;
		me.totalCount = totalCount;

		me.categoryLoader = false;
	}
	
	async downloadButton() {
		window.location.href = this.templateService.siteSubCategories.downloadFileRoute(
			this.filter.filterParams,
			'download_abs'
		)

		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}
}
